<template>
  <div class="authority">
    <div class="header">
      <div class="title">权威认证</div>
      <div class="border"></div>
    </div>
    <div class="body">
      <div class="list" ref="all">
        <div
          class="item"
          v-for="item in authorityList"
          :key="item.id"
          :ref="(el) => setItemRef(el, item.id)"
          :style="'transform: translateX(' + item.translateNum + 'px)'"
        >
          <img :src="item.pictrue" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, nextTick, inject } from "vue";

// 注入 axios
const axios = inject("$axios");

const authorityList = ref([]);
const fetchData = async () => {
  try {
    // 方式一
    const res = await axios.get("api/renren-fast/generator/cjaboutcertificates/list?limit=999");
    console.log("请求成功:", res);
    authorityList.value = res.data.page.list;
    search();
  } catch (error) {
    console.error("请求失败:", error);
  }
};

// ========== 常量配置 ==========
const ITEM_WIDTH = 180; // 图片宽度
const ITEM_MARGIN = 20; // 右边距
const TOTAL_ITEM_WIDTH = ITEM_WIDTH + ITEM_MARGIN; // 每个 item 总宽度 200px
const ITEM_COUNT = 17; // item 数量

// ========== 数据 ==========

// ========== DOM 引用 ==========
const all = ref(null);
const demoItem = ref({});

// ========== 定时器 ==========
let timer = null;

// ========== 设置 ref ==========
const setItemRef = (el, id) => {
  if (el) {
    demoItem.value[id] = el;
  }
};

// ========== 搜索初始化 ==========
const search = () => {
  // 重置所有 translateNum 为 0
  for (let i = 0; i < authorityList.value.length; i++) {
    authorityList.value[i].translateNum = 0;
  }

  // 在元素完全渲染后获取位置
  nextTick(() => {
    // 获取每个 item 的初始位置
    for (let j = 0; j < authorityList.value.length; j++) {
      const itemId = authorityList.value[j].id;
      const el = demoItem.value[itemId];
      if (el) {
        // 使用 getBoundingClientRect 获取更准确的位置
        const rect = el.getBoundingClientRect();
        const parentRect = all.value?.getBoundingClientRect();
        if (parentRect) {
          // 计算相对于父容器的偏移
          authorityList.value[j].indexLeft = rect.left - parentRect.left;
        } else {
          // 降级方案：使用 offsetLeft
          authorityList.value[j].indexLeft = el.offsetLeft;
        }
      }
    }

    // 启动滚动
    startRoll();
  });
};

// ========== 启动滚动 ==========
const startRoll = () => {
  // 清除旧定时器
  if (timer) {
    clearInterval(timer);
    timer = null;
  }

  // 使用 requestAnimationFrame 实现更流畅的动画
  let lastTime = 0;
  let accumulatedDistance = 0;

  const animate = (currentTime) => {
    if (!lastTime) {
      lastTime = currentTime;
    }

    // 计算时间差，控制动画速度
    const deltaTime = currentTime - lastTime;
    lastTime = currentTime;

    // 每 16ms 移动 1px（约 60fps）
    accumulatedDistance += deltaTime / 16;

    if (accumulatedDistance >= 1) {
      const movePixels = Math.floor(accumulatedDistance);
      accumulatedDistance -= movePixels;

      // 更新每个 item 的位置
      for (let i = 0; i < authorityList.value.length; i++) {
        const item = authorityList.value[i];

        // 判断是否超出边界
        // 总宽度 = item数量 × 每个item占用的总宽度
        const totalWidth = ITEM_COUNT * TOTAL_ITEM_WIDTH;

        // 如果元素即将超出父容器左侧边界
        if (totalWidth - item.translateNum - item.indexLeft < 0) {
          // 重置到右侧起始位置
          item.translateNum = -item.indexLeft - ITEM_WIDTH;
        }

        // 向左移动
        item.translateNum = item.translateNum + movePixels;
      }
    }

    // 继续动画
    timer = requestAnimationFrame(animate);
  };

  // 启动动画
  timer = requestAnimationFrame(animate);
};

// ========== 生命周期 ==========
onMounted(() => {
  fetchData();
});

onBeforeUnmount(() => {
  if (timer) {
    cancelAnimationFrame(timer);
    timer = null;
  }
});
</script>

<style scoped>
.authority {
  width: 1180px;
  margin: 80px auto 0;
}
.header .title {
  font-size: 30px;
  text-align: center;
}
.header .border {
  width: 40px;
  height: 5px;
  background: #248efb;
  margin: 20px auto 0;
}

.body {
  margin-top: 40px;
}
.body .list {
  width: 1180px;
  display: flex;
  align-items: center;
  justify-content: left;
  overflow: hidden;
  position: relative;
}
.body .list .item {
  flex-shrink: 0;
}
.body .list .item img {
  width: 180px;
  margin-right: 20px;
  display: block;
}
</style>
